import { render, staticRenderFns } from "./abroad-employee-history.vue?vue&type=template&id=0f2660f1&scoped=true&"
import script from "./abroad-employee-history.vue?vue&type=script&lang=js&"
export * from "./abroad-employee-history.vue?vue&type=script&lang=js&"
import style0 from "./abroad-employee-history.vue?vue&type=style&index=0&id=0f2660f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2660f1",
  null
  
)

export default component.exports